import React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import {
  Mloc,
  PMCConfig,
  ProviderMatchProviderLocationV9
} from '@kyruus/types';

import Map from './map';

import ExpandableCardContainer from '../ExpandableCardContainer/expandable-card-container';
import { LocationsSectionHeader, LocationsList } from './styles';

import { TrackingFunction } from '../../lib/tracking-utils';
import messages from '../../lib/messages';
import Location from './location';
import { withErrorBoundary } from '../ErrorFallback/with-error-boundary';
import { AwsMapConfig } from '@kyruus/aws-map';

interface ProviderLocationsProps {
  locations: ProviderMatchProviderLocationV9[];
  mlocations: { [key: string]: Mloc };
  getLocationUrl: (location: ProviderMatchProviderLocationV9) => string | null;
  locationCallback?: (locationUrl: string, isExternal: boolean) => void;
  googleMapsUrl?: string;
  track: TrackingFunction;
  config: PMCConfig;
  awsMapConfig: AwsMapConfig;
}

const ProviderLocations = ({
  locations,
  mlocations,
  getLocationUrl,
  locationCallback,
  googleMapsUrl,
  track,
  config,
  awsMapConfig
}: ProviderLocationsProps): React.ReactElement => {
  return (
    <ExpandableCardContainer id="profile-locations-section" track={track}>
      <LocationsSectionHeader>
        <FormattedMessage {...messages.providerLocationsHeader} />
      </LocationsSectionHeader>
      <Map
        locations={locations}
        config={config}
        googleMapsUrl={googleMapsUrl}
        awsMapConfig={awsMapConfig}
      />
      <LocationsList>
        {locations.map((loc) => (
          <Location
            key={loc.external_id as string}
            location={loc}
            getLocationUrl={getLocationUrl}
            locationCallback={locationCallback}
            mloc={mlocations[loc.primary_marketable_location_id as string]}
            config={config}
          />
        ))}
      </LocationsList>
    </ExpandableCardContainer>
  );
};

export default withErrorBoundary(ProviderLocations);
